/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminnav_Credit1Inputs */

const zh_adminnav_credit1 = /** @type {(inputs: Adminnav_Credit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点数管理`)
};

const en_adminnav_credit1 = /** @type {(inputs: Adminnav_Credit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credit Management`)
};

const es_adminnav_credit1 = /** @type {(inputs: Adminnav_Credit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de créditos`)
};

/**
* | output |
* | --- |
* | "Credit Management" |
*
* @param {Adminnav_Credit1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminnav_credit1 = /** @type {((inputs?: Adminnav_Credit1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminnav_Credit1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminnav_credit1(inputs)
	if (locale === "en") return en_adminnav_credit1(inputs)
	return es_adminnav_credit1(inputs)
});
export { adminnav_credit1 as "adminNav_credit" }